import { DASHBOARD_ROUTES } from "./dashboardRoutes";
import { EXPLORE_ROUTES } from "./exploreRoutes";
import { GAMIFICATION_ROUTES } from "./gamification/gamificationRoutes";
import React from "react";
import { useNavigate } from "react-router-dom";
import "./GamesPreviousYear.css";
import { buildRapidFireBattleItems } from "../utils/dashboardStats";
import { getStoredUser } from "../utils/authStorage";

const GamesSection = ({ battles = [], isLoading = false, error = "" }) => {
  const navigate = useNavigate();
  const games = buildRapidFireBattleItems(battles);
  const storedUser = getStoredUser();
  const stateId = storedUser?.state_id || storedUser?.stateId || storedUser?.user_state_id || 0;
  const stateName = storedUser?.state_name || storedUser?.stateName || storedUser?.user_state_name || "";
  const selectedState = { state_id: stateId, state_name: stateName };

  const openGamification = (route = GAMIFICATION_ROUTES.start) => navigate(route, {
    state: {
      selectedState,
      state_id: stateId,
      selectedCategory: { category_id: 6, title: "Gamification" },
      category_id: 6,
      gamificationBackTarget: { pathname: DASHBOARD_ROUTES.home, state: {} },
    },
  });

  const openGame = (game) => {
    if (game.route === EXPLORE_ROUTES.subjects) {
      const isBattle = game.battleId > 0;
      const categoryId = isBattle ? 6 : 5;
      const categoryName = isBattle ? "Gamification" : "Rapid Fire";
      navigate(game.route, {
        state: {
          selectedState,
          state_id: stateId,
          selectedCategory: { category_id: categoryId, title: categoryName },
          category_id: categoryId,
          selectedSubject: null,
          subject_id: 0,
          selectedTopic: null,
          selectedSubtopic: null,
          topicRequestParams: null,
          subTopicRequestParams: null,
          listQueryState: {},
          ...(isBattle ? {
            selectedBattle: {
              battles_id: game.battleId,
              battles_name: game.title,
              battles_description: game.description,
              battles_image: game.image,
            },
            battles_id: game.battleId,
          } : { selectedBattle: null, battles_id: 0 }),
          qbankBackTarget: { pathname: DASHBOARD_ROUTES.home, state: {} },
        },
      });
      return;
    }
    openGamification(game.route);
  };

  return (
    <div className="games-section">
      <div className="quick-action__header">
        <h2 className="quick-action__title">
          Games & Challenges
        </h2>

        {!isLoading ? (
          <button type="button" className="quick-action__see-all" onClick={() => openGamification()}>
            See All
          </button>
        ) : (
          <span className="dashboard-skeleton dashboard-skeleton--button" aria-hidden="true" />
        )}
      </div>

      {isLoading ? (
        <div className="dashboard-skeleton-grid dashboard-skeleton-grid--games" aria-hidden="true">
          {Array.from({ length: 2 }).map((_, index) => (
            <div className="game-card dashboard-skeleton-media-card" key={index}>
              <span className="dashboard-skeleton dashboard-skeleton--thumb" style={{ height: "100%" }} />
            </div>
          ))}
        </div>
      ) : null}
      {!isLoading && error ? <p className="quick-action__status quick-action__status--error">{error}</p> : null}
      {!isLoading && !error && !games.length ? (
        <p className="quick-action__status">No games available.</p>
      ) : null}

      {!isLoading && !error && games.length ? (
      <div className="games-list">
        {games.map((game) => (
          <div className="game-card" key={game.id}>
            <img src={game.image} alt={game.title} />

            <div className="overlay">
              <h4>{game.title}</h4>

              <button type="button" aria-label={`${game.buttonLabel}: ${game.title}`} onClick={() => openGame(game)}>{game.buttonLabel}</button>
            </div>
          </div>
        ))}
      </div>
      ) : null}
    </div>
  );
};

export default GamesSection;
